import Vue from 'vue'
import httpList from './httplist'

export default {
  utils () {
    Vue.prototype.pr = function (path) {
      this.$router.push(path)
    }
    Vue.prototype.showLoading = function (mes = '加载中...') {

      loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
      })
      return httpList
    }
    // Vue.prototype.showToast=function(mes){
    //     Toast({
    //         message:mes,
    //         duration:1500,
    //         overlay:false
    //     })
    //     return httpList;
    // },
    // Vue.prototype.confirm=function(mes,callback){
    //     Dialog.confirm(mes,"提示",{
    //         confirmButtonText: '确定',
    //         cancelButtonText: '取消',
    //         type: 'warning'
    //     }).then(()=>{
    //         callback();
    //     }).catch(()=>{

    //     })
    // }
  }
}



// WEBPACK FOOTER //
// ./src/util/index.js